import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    quote: '[Testimonial în curs de colectare - Citat direct de la Denisa, mama copilului de 5 ani și jumătate. Extras din înregistrarea video.]',
    name: 'Denisa',
    context: 'Mama unui băiețel de 5 ani și jumătate',
    image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=200&q=80',
    accent: 'border-brand-gold'
  }, {
    quote: '[Testimonial în curs de colectare - Citat direct de la mama lui Florin, copilul de 1 an și 3 luni care avea joc repetitiv și nu răspundea la strigarea pe nume.]',
    name: 'Mama lui Florin',
    context: 'Băiețel de 1 an și 3 luni',
    image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=200&q=80',
    accent: 'border-brand-coral'
  }, {
    quote: '[Testimonial în curs de colectare - Povești de succes suplimentare ce urmează a fi furnizate de Cristina.]',
    name: 'Nume Client',
    context: 'Ocupație / Titlu client',
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=200&q=80',
    accent: 'border-brand-gold'
  }];
  return <section className="bg-brand-ivory section-padding relative overflow-hidden" data-id="element-337">
      {/* Decorative Background Shapes */}
      <svg className="absolute top-0 right-0 w-[600px] h-[600px] text-brand-beige -z-10 translate-x-1/3 -translate-y-1/3" viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg" data-id="element-338">
        <path fill="currentColor" d="M44.7,-76.4C58.8,-69.2,71.8,-59.1,81.3,-46.3C90.8,-33.5,96.8,-18,96.5,-2.7C96.2,12.6,89.6,27.7,80.1,40.7C70.6,53.7,58.2,64.6,44.2,72.4C30.2,80.2,15.1,84.9,-0.3,85.4C-15.7,85.9,-31.4,82.2,-45.5,74.5C-59.6,66.8,-72.1,55.1,-80.6,41.1C-89.1,27.1,-93.6,10.8,-92.4,-5.1C-91.2,-21,-84.3,-36.5,-74.4,-49.2C-64.5,-61.9,-51.6,-71.8,-37.8,-79.1C-24,-86.4,-9.3,-91.1,3.2,-86.6C15.7,-82.1,30.6,-83.6,44.7,-76.4Z" transform="translate(100 100)" data-id="element-339" />
      </svg>

      <div className="container-custom relative z-10" data-id="element-340">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} className="text-center mb-16" data-id="element-341">
          <h2 className="text-[32px] md:text-[42px]" data-id="element-342">
            Ce spun mamele care au lucrat cu mine
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-343">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          delay: index * 0.15,
          duration: 0.5
        }} className={`bg-white p-8 rounded-[16px] shadow-card relative border-l-[6px] ${testimonial.accent} hover:-translate-y-2 transition-transform duration-300`} data-id="element-344">
              {/* Decorative Quotes SVG */}
              <svg className="absolute top-6 right-6 w-16 h-16 text-brand-gold/10" fill="currentColor" viewBox="0 0 24 24" data-id="element-345">
                <path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.983zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h3.983v10h-9.983z" data-id="element-346" />
              </svg>

              <div className="relative z-10" data-id="element-347">
                <div className="flex gap-1 mb-6" data-id="element-348">
                  {[...Array(5)].map((_, i) => <StarIcon key={i} size={18} className="fill-brand-gold text-brand-gold" data-id="element-349" />)}
                </div>

                <p className="font-source text-[16px] italic text-brand-text mb-8 leading-relaxed min-h-[120px]" data-id="element-350">
                  "{testimonial.quote}"
                </p>

                <div className="flex items-center gap-4" data-id="element-351">
                  <div className="w-14 h-14 rounded-full overflow-hidden border-2 border-brand-gold/30 flex-shrink-0" data-id="element-352">
                    <img src={testimonial.image} alt={testimonial.name} className="w-full h-full object-cover" data-id="element-353" />
                  </div>
                  <div data-id="element-354">
                    <h4 className="font-montserrat font-semibold text-[14px] text-brand-navy mb-1" data-id="element-355">
                      {testimonial.name}
                    </h4>
                    <p className="font-montserrat font-normal text-[13px] text-brand-textSecondary" data-id="element-356">
                      {testimonial.context}
                    </p>
                  </div>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}